module.exports = __webpack_public_path__ + "img/mq.ee3f8b70.svg";